module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_bucketpl.66a7bdf25a774b42726374b021a06558.png";